import axios from "axios";

// EXR lead submission, per https://gist.github.com/ssbb/356b4ed7a85a944084b989b3705ad244
// POST https://www.exrplatform.com/api/leads/
// Required: email. Optional: full_name, phone_number, move_in_date, layout,
// message, source (site slug), tracking (object from localStorage), etc.
// Errors come back as {errors: [{key, ...}]}.
const LEADS_ENDPOINT =
  process.env.REACT_APP_LEADS_ENDPOINT || "https://www.exrplatform.com/api/leads/";

export const LEAD_SOURCE = "150bk.com";

export function submitLead(fields) {
  let tracking = null;
  try {
    tracking = JSON.parse(localStorage.getItem("tracking"));
  } catch (err) {
    tracking = null;
  }
  return axios.post(LEADS_ENDPOINT, { source: LEAD_SOURCE, tracking, ...fields });
}
